import { render } from "./Indicator.vue?vue&type=template&id=3749f1ec&ts=true"
import script from "./Indicator.vue?vue&type=script&lang=ts"
export * from "./Indicator.vue?vue&type=script&lang=ts"

import "./Indicator.vue?vue&type=style&index=0&id=3749f1ec&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__